module.exports = __webpack_public_path__ + "static/media/BovExo_template_pesagens.1e620b06.xlsx";